import React, { useEffect, useState } from "react";
import CheckoutSteps from "../components/CheckoutSteps";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { getOrder } from "../actions/orderActions";
import Message from "../components/Message";
import { formatPrice } from "../utils/formatPrice.js";
import Loader from "../components/Loader";
import { Button, Row, Col, ListGroup, Image, Card } from "react-bootstrap";

const OrderDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, loading, error } = orderDetails;
  useEffect(() => {
    if (id) {
      dispatch(getOrder(id));
    }
  }, [dispatch]);
  return loading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error}</Message>
  ) : (
    <>
      <Row>
        <Col md={6} style={{ borderRight: "1px solid lightgrey" }}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3 style={{ lineHeight: "5rem" }}>
                <span>
                  <i
                    class="fa fa-check-circle"
                    style={{ color: "#4ead4e", fontSize: "1.6rem" }}
                  />
                </span>{" "}
                Order Successful
              </h3>
              <p>
                <strong>Customer Email: </strong>{" "}
                <a href={`mailto:${order.customer.email}`}>
                  {order.customer.email}
                </a>
              </p>
              <p>
                <strong>Customer Name: </strong>{" "}
                <a>
                  {order.customer.first_name + " " + order.customer.last_name}
                </a>
              </p>
              <p>
                <strong>Order ID</strong> &mdash; <a>{order.order_track_id}</a>
              </p>
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={6}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3 style={{ lineHeight: "5rem" }}>
                <span>
                  <i
                    class="fa fa-list-alt"
                    style={{ color: "#4ead4e", fontSize: "1.6rem" }}
                  />
                </span>
                Order Summary
              </h3>
              <p>
                <strong>Sub Total: </strong>
                <a>
                  {formatPrice((order.total_price) -
                    order.total_sales_tax)}
                </a>
              </p>
              <p>
                <strong>Total Tax: </strong>
                <a>{formatPrice(order.total_sales_tax)}</a>
              </p>
              <p>
                <strong>Total Amount: </strong>
                <a>{formatPrice(order.total_price)}</a>
              </p>

              {/* </Row> */}
            </ListGroup.Item>
            {order.order_note && (
              <ListGroup.Item>
                <Card style={{ width: "18rem" }}>
                  <Card.Body>
                    <Card.Title>Order Note</Card.Title>
                    {/* <Card.Subtitle className="mb-2 text-muted">
                    Card Subtitle
                  </Card.Subtitle> */}
                    <Card.Text>{order.order_note}</Card.Text>
                    {/* <Card.Link href="#">Card Link</Card.Link>
                    <Card.Link href="#">Another Link</Card.Link> */}
                  </Card.Body>
                </Card>
              </ListGroup.Item>
            )}
          </ListGroup>
        </Col>
      </Row>
    </>
  );
};

export default OrderDetails;
